<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="SearchBorder">
					<div class="CenterGrid">
						<label>First Name:</label>
						<input [disabled]="loading" type="text" class="form-control" [(ngModel)]="FirstName" />

						<label>Last Name:</label>
						<input [disabled]="loading" type="text" class="form-control" [(ngModel)]="LastName" />

						<label>License Number:</label>
						<input [disabled]="loading" type="text" class="form-control" [(ngModel)]="LicenseNbr" />

						<label>State:</label>
						<input [disabled]="loading" type="text" class="form-control" [(ngModel)]="State" />

						<label>Date of Birth:</label>
						<p-calendar [disabled]="loading" showIcon="true" showButtonBar="true" [(ngModel)]="DOB" name="DOB"></p-calendar>

						<label>License Issue Date:</label>
						<p-calendar [disabled]="loading" showIcon="true" showButtonBar="true" [(ngModel)]="IssueDate" name="IssueDate"></p-calendar>

						<label>License Expire Date:</label>
						<p-calendar [disabled]="loading" showIcon="true" showButtonBar="true" [(ngModel)]="ExpireDate" name="ExpireDate"></p-calendar>
					</div>

					<div class="Buttons">
						<button [disabled]="loading" class="btn btn-primary" (click)="onManualLookup()">Search</button>
					</div>
				</div>

				<div class="ResultCompareGrid">
					<!--Current Person Data-->
					<div class="ResultBorder">
						<h4 style="text-align: center">Visitor</h4>

						<!--Image-->
						<div class="ImgDiv">
							<img [src]="TestImage" />
						</div>

						<!--Info-->
						<div class="OffenderInfoGrid">
							<label>First Name:</label>
							<p>{{ FirstName }}</p>

							<label>Last Name:</label>
							<p>{{ LastName }}</p>

							<label>License Number:</label>
							<p>{{ LicenseNbr }}</p>

							<label>DOB:</label>
							<p>{{ FormatDate(DOB) }}</p>
						</div>
					</div>

					<!--Offender Matches-->
					<div class="ResultBorder">
						<h4 style="text-align: center">Possible Match</h4>

						<!--Image-->
						<div *ngIf="SelectedResult != null" class="ImgDiv">
							<img [src]="SelectedResult.OffenderImage" />
						</div>

						<!--Name, etc.-->
						<div *ngIf="SelectedResult != null">
							<!--Basic-->
							<div class="OffenderInfoGrid">
								<label>First Name:</label>
								<p>{{ SelectedResult.FirstName }}</p>

								<label>Middle Name:</label>
								<p>{{ SelectedResult.MiddleName }}</p>

								<label>Last Name:</label>
								<p>{{ SelectedResult.LastName }}</p>

								<label>Height:</label>
								<p>{{ SelectedResult.Height }}</p>

								<label>Weight:</label>
								<p>{{ SelectedResult.Weight }}</p>

								<label>Sex:</label>
								<p>{{ SelectedResult.Sex }}</p>

								<label>Race:</label>
								<p>{{ SelectedResult.Race }}</p>

								<label>DOB:</label>
								<p>
									{{ FormatOffenderInfoDate(SelectedResult.DOB) }}
								</p>

								<label>State:</label>
								<p>{{ SelectedResult.Source }}</p>
							</div>

							<!--Expand-->
							<div class="OffenderInfoGrid">
								<label>Offence:</label>
								<p>{{ SelectedResult.OffenseDescription1 }}</p>
							</div>

							<div *ngIf="SelectedResult != null" class="OffenderInfoGrid">
								<label>{{ ResultIndex + 1 }}/{{ lstResults.length }}</label>
							</div>
						</div>

						<!--Buttons-->
						<div class="Buttons">
							<button [disabled]="loading == true" *ngIf="ResultIndex > 0 && lstResults.length > 0" class="btn btn-primary" (click)="onBack()">
								<i class="fa fa-chevron-left" aria-hidden="true"></i>
							</button>
							<button [disabled]="loading == true" *ngIf="loading == true || lstResults.length > 0" class="btn btn-danger">Offender Match</button>
							<button [disabled]="loading == true" *ngIf="loading == true || lstResults.length > 0" class="btn btn-primary" (click)="onNext()">
								<i class="fa fa-chevron-right" aria-hidden="true"></i>
							</button>
						</div>
						<!--Finish?-->
						<div class="Buttons">
							<button
								[disabled]="loading == true"
								*ngIf="loading == false && (lstResults.length == 0 || ResultIndex == lstResults.length - 1)"
								class="btn btn-success"
							>
								Finish (Not a Sex Offender)
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
